import s from '@/styles/components/Icon.module.scss'
import { FC, SVGProps } from 'react'
import { Icons } from '@/components'
import { classNames } from '@tmap-web-lib/utils'

interface IconProps extends SVGProps<SVGSVGElement> {
  name: keyof typeof Icons;
  size?: number | string;
  color?: string;
  className?: string;
}

export const Icon: FC<IconProps> = ({
  name,
  size = 20,
  color = '--icon-primary',
  className,
  ...props
}) => {
  const IconComponent = Icons[name]
  return (
    <i className={classNames(s.wrap, className)}>
      <IconComponent
        width={size}
        height={size}
        style={{ color: `var(${color})` }}
        {...props}
      />
    </i>
  )
}
